<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('contacts')">{{__('Users')}}</inertia-link>
      <span class="text-indigo-400 font-medium">/</span> {{__('Create')}}
    </h1>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.first_name" :error="form.errors.first_name" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('First Name')" />
          <text-input v-model="form.last_name" :error="form.errors.last_name" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Last Name')" />
          <!-- <text-input v-model="form.ref_no" :error="form.errors.ref_no" class="pr-6 pb-8 w-full lg:w-1/2" label="Ref. No" /> -->
          <select-input v-if="$page.props.auth.user.customer_id == 0" v-model="form.organization_id" :error="form.errors.organization_id" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Customer')">
            <option :value="null" />
            <option v-for="organization in organizations" :key="organization.id" :value="organization.id">{{ organization.name }}</option>
          </select-input>
          <text-input v-model="form.email" :error="form.errors.email" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Email')" />
          <text-input v-model="form.password" :error="form.errors.password" class="pr-6 pb-8 w-full lg:w-1/2" type="password" autocomplete="new-password" :label="__('Password')" />
          <text-input v-model="form.business_name" :error="form.errors.business_name" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Bakery Name')" />
          <text-input v-model="form.phone" :error="form.errors.phone" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Phone')" />
          <!-- <select-input v-model="form.lang" :error="form.errors.lang" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Language')">
            <option value="nl" > Dutch </option>
            <option value="en" > English </option>
            <option value="fr" > French </option>
          </select-input> -->
          <text-input v-model="form.vat_no" :error="form.errors.vat_no" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('VAT No.')" />
        </div>
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <!-- Invoice address -->
          <text-input v-model="form.address" :error="form.errors.address" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Invoice Address street + Number')" />
          <text-input v-model="form.city" :error="form.errors.city" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('City')" />
          <!-- <text-input v-model="form.region" :error="form.errors.region" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Province/State')" /> -->
          <select-input v-model="form.country" :error="form.errors.country" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Country')">
            <option :value="null" > {{__('Select Country')}} </option>
            <option v-for="(countryItem, index) in $page.props.countries" :key="index" :value="countryItem.iso2">{{countryItem.name}}</option>
          </select-input>
          <text-input v-model="form.postal_code" :error="form.errors.postal_code" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Postal code')" />

          <!-- <text-input v-model="form.address_ref_no" :error="form.errors.address_ref_no" class="pr-6 pb-8 w-full lg:w-1/2" label="Address Ref. No" /> -->
          
            <!-- <select-input v-model="form.ind_kitchen" :error="form.errors.ind_kitchen" class="pr-6 pb-8 w-full lg:w-1/2" label="Kitchen Type">
              <option :value="0" > {{__('Normal Kitchen')}} </option>
              <option :value="1" > {{__('Independent Kitchen')}} </option>
            </select-input> -->
        </div>

         <!-- Shipping address -->
        <div class="p-12 -mr-6 -mb-8 flex flex-wrap" v-if="form.sameAsInvoive">
    
            <input
              type="checkbox"
              name="sameAsInvoive"
              :value="form.sameAsInvoive"
              v-model="form.sameAsInvoive"
              style="margin-right: 10px;"
            />
            <label for="sameAsInvoive">{{__('Shipping Address Same As Invoice')}}</label>
       
          </div>
          <div class="p-8 -mr-6 -mb-8 flex flex-wrap" v-if="!form.sameAsInvoive">

            <text-input v-model="form.shipping_address" :error="form.errors.shipping_address" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Shipping Address street + Number')" />
              <text-input v-model="form.shipping_city" :error="form.errors.shipping_city" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('City')" />
              <!-- <text-input v-model="form.shipping_region" :error="form.errors.shipping_region" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Province/State')" /> -->
              <select-input v-model="form.shipping_country" :error="form.errors.shipping_country" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Country')">
                <option :value="null" > {{__('Select Country')}} </option>
                <option v-for="(countryItem, index) in $page.props.countries" :key="index" :value="countryItem.iso2">{{countryItem.name}}</option>
              </select-input>
              <text-input v-model="form.shipping_postal_code" :error="form.errors.shipping_postal_code" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Postal code')" />
          </div>
       
         
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">{{__('Create')}} {{__('User')}}</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  metaInfo: { title: 'Create Contact' },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
  },
  layout: Layout,
  props: {
    organizations: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        first_name: null,
        last_name: null,
        ref_no: null,
        organization_id: null,
        email: null,
        password: null,
        business_name: null,
        phone: null,
        address: null,
        city: null,
        region: null,
        country: null,
        postal_code: null,
        address_ref_no: null,
        lang: 'nl',
        vat_no: null,
        ind_kitchen: 0,
        shipping_address: null,
        shipping_city: null,
        shipping_region: null,
        shipping_country: null,
        shipping_postal_code: null,
        sameAsInvoive: true
      }),
    }
  },
  methods: {
    store() {
      if(this.form.organization_id == null && this.$page.props.auth.user.customer_id > 0){
        this.form.organization_id =  this.$page.props.auth.user.customer_id
      }
      this.form.post(this.route('contacts.store'))
    },
  },
}
</script>
